<template>
  <v-menu
    ref="actionSelectMenu"
    v-model="isMenuShown"
    :absolute="true"
    top
    left
    origin="right bottom"
    transition="scale-transition"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :color="color"
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon>mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item-group v-if="isMainMenuShown">
        <v-list-item @click="download">
          <v-list-item-icon>
            <v-icon>mdi-download</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Скачать</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="showMainMenu(false)">
          <v-list-item-icon>
            <v-icon>mdi-play-speed</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Скорость воспроизведения</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
      <template v-else>
        <v-list-item @click="showMainMenu">
          <v-list-item-content>
            <div class="d-inline-flex align-center">
              <v-icon class="mr-3">
                mdi-arrow-left
              </v-icon>
              <v-list-item-title>Назад</v-list-item-title>
            </div>
          </v-list-item-content>
        </v-list-item>
        <v-list-item-group v-model="rate">
          <v-list-item
            v-for="item in playbackRates"
            :key="'pr_' + item"
            :value="item"
          >
            <v-list-item-content>
              <v-list-item-title>
                {{ item === 1 ? 'Обычный' : item }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'ActionSelect',
    props: {
      color: String,
      playbackRates: Array,
      playbackRate: Number,
      src: String,
    },
    data () {
      return {
        isMenuShown: false,
        isMainMenuShown: true,
      }
    },
    computed: {
      rate: {
        get () {
          return this.playbackRate
        },
        set (value) {
          this.isMenuShown = false
          this.isMainMenuShown = true
          this.$emit('update:playbackRate', value)
        },
      },
    },
    watch: {
      isMenuShown (val) {
        if (!val) {
          this.isMainMenuShown = true
        }
      },
    },
    methods: {
      showMainMenu (value = true) {
        this.isMainMenuShown = value
        this.$refs.actionSelectMenu.updateDimensions()
        this.$refs.actionSelectMenu.calcLeft()
        this.$refs.actionSelectMenu.calcTop()
      },
      download () {
        this.isMenuShown = false
        const link = document.createElement('a')
        link.href = this.src
        link.target = '_blank'
        link.download = this.src.substring(this.src.lastIndexOf('/') + 1)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      },
    },
  }
</script>

<style scoped lang="less"></style>
